import { IconPlus, IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { loadingHide, loadingShow } from '../../../../loadingUi/loading.controller';
import { postApi } from '../../../../api/call.api';
import { urlApi } from '../../../../api/url.api';

const AddHighlightColorModal = ({ callback }) => {

    const [show, setShow] = useState(false);

    const handleClose = () => { setShow(false) };
    const handleShow = () => setShow(true);

    const add = async () => {
        let postData = {
            "colorCode": document.getElementById("color").value,
            "name": document.getElementById("name").value
        }
        if (!postData.colorCode || !postData.name) {
            toast.error("Please fill all fields");
            return;
        }
        loadingShow();
        let resp = await postApi(postData, urlApi.addChatHighlightColor);
        loadingHide();
        if (resp?.responseCode === 200) {
            callback?.();
            toast.success(resp?.message);
            handleClose();
            document.getElementById("color").value = "#ffffff"; // Reset color input
            document.getElementById("name").value = ""; // Reset name input
        } else {
            toast.error(resp?.message);
        }
    }

    return (
        <>
            <button
                className="px-3 py-2 bg-orange-500 text-white rounded-md text-sm hover:bg-orange-600 transition flex gap-2" onClick={handleShow}
            >
                <IconPlus size={18} /> Add
            </button>

            <Modal show={show} onHide={handleClose} backdrop="static" >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold mb-0">Add New Highlight Color</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />

                    <div className="space-y-4 mb-4">
                        <div className="flex flex-col">
                            <label htmlFor="color" className="text-sm font-medium text-gray-700 mb-1">
                                Choose Color
                            </label>
                            <input
                                type="color"
                                id="color"
                                defaultValue={"#00FF00"}
                                className="w-full h-10 rounded border border-gray-300 cursor-pointer"
                            />
                        </div>

                        <div className="flex flex-col">
                            <label htmlFor="name" className="text-sm font-medium text-gray-700 mb-1">
                                Name
                            </label>
                            <input
                                type="text"
                                id="name"
                                placeholder="e.g., Important, Urgent"
                                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
                            />
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => add()}>Add</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default AddHighlightColorModal